// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px)";
var _3 = "screen and (max-width: 600px)";
var _4 = "segments-2_MOj";
var _5 = "segments_multiCity-2Ef_w";
var _6 = "actions-tmprx";
var _7 = "addSegment-pF-4c";
var _8 = "removeSegment-2qfRF";
var _9 = "alternative-2JxWI";
export { _1 as "__esModule", _2 as "tablet", _3 as "mobile", _4 as "segments", _5 as "segments_multiCity", _6 as "actions", _7 as "addSegment", _8 as "removeSegment", _9 as "alternative" }
export default { "__esModule": _1, "tablet": _2, "mobile": _3, "segments": _4, "segments_multiCity": _5, "actions": _6, "addSegment": _7, "removeSegment": _8, "alternative": _9 }
